import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { CreditCard, Timer } from "lucide-react";

import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import ImageGallery from "../../components/ImageGallery";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/af91b13e-e0c0-4207-b452-8b844c593623" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen5,field_imagen6,field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

// Variantes de animación reutilizables
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

export default function Competencias() {
  const [activeTab, setActiveTab] = useState("carrera");

  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      />

      {data.bloque1 && (
        <section className="bluebg">
          <div className="max-w-6xl m-auto px-6 py-24">
            <div
              className="  button-a [&_a]:m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque1,
              }}
            />
          </div>
        </section>
      )}
      <section className="max-w-6xl m-auto px-6 py-24 text-center ">
        <div className="grid gril-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50  p-4">
            <div className=" m-auto w-16 h-16 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600">
              <Timer className="w-8 h-8 block translate-y-[1px]" />
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          </div>
          <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-4">
            <div className="m-auto w-16 h-16 rounded-2xl flex items-center justify-center bg-blue-50 text-blue-600">
              <CreditCard className="w-8 h-8 block translate-y-[1px]" />
            </div>

            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque3,
              }}
            />
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-50 ">
        <div
          className=" max-w-6xl m-auto px-6 link-with-arrow-1  "
          dangerouslySetInnerHTML={{
            __html: data.bloque4,
          }}
        />
      </section>

      <BlockLeftImage
        src={data.imagen5}
        content={
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque5,
              }}
            />
          </>
        }
      ></BlockLeftImage>

      <BlockRightImage
        src={data.imagen6}
        content={
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque6,
              }}
            />
          </>
        }
      >
        {" "}
      </BlockRightImage>

      <section className="max-w-6xl button-a m-auto py-24">
        <div
          className="max-w-6xl m-auto"
          dangerouslySetInnerHTML={{
            __html: data.bloque7,
          }}
        />
      </section>
      <section className="py-10 bg-gray-100" >

        <div className="max-w-5xl px-6  m-auto "> 
        <h2 className="text-center font-bold mb-10"> Conoce los procesos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <ImageGallery gallery={data.galeria}></ImageGallery>
          </div>

          <div>
            <ImageGallery gallery={data.galeria1}></ImageGallery>
          </div>
        </div></div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
